import { Seo } from "@/components/Seo";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { industries } from "@/data/industries";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";

const IndustryCard = ({
  slug,
  title,
  benefit,
  bullets,
  roi,
  img,
  alt,
}: (typeof industries)[number]) => (
  <Card className="overflow-hidden rounded-md shadow-sm h-full">
    <img src={img} alt={alt} loading="lazy" className="h-40 w-full object-cover" />
    <CardHeader className="p-4">
      <CardTitle className="text-xl">{title}</CardTitle>
      <p className="text-base text-muted-foreground">{benefit}</p>
    </CardHeader>
    <CardContent className="p-4 pt-0 flex flex-col">
      <ul className="list-disc pl-5 space-y-2 text-base text-muted-foreground flex-1">
        {bullets.map((b) => (
          <li key={b}>{b}</li>
        ))}
      </ul>
      <p className="mt-3 text-base text-muted-foreground">{roi}</p>
      <Button variant="outline" className="mt-4 w-full" asChild>
        <Link to={`/industries/${slug}`} aria-label={`Learn more about ${title} automation solutions`}>
          Learn more about {title}
        </Link>
      </Button>
    </CardContent>
  </Card>
);

const Industries = () => (
  <>
    <Seo 
      title="AI Automation by Industry - Law, Medical, Real Estate, Fitness | AI Montclair"
      description="Specialized AI solutions for law firms, medical practices, real estate agents, and fitness studios in Montclair, NJ."
      canonical="/industries"
    />
    <Navbar />
    <div className="min-h-screen">
      {/* Header */}
      <header className="bg-[hsl(var(--section-subtle))] py-16 md:py-20">
        <div className="container mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-semibold mb-4">
            Industries We Serve
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
            AI Montclair transforms businesses across diverse industries with tailored AI solutions that drive efficiency and growth.
          </p>
        </div>
      </header>

      {/* Industries Grid */}
      <main className="container mx-auto py-16">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {industries.map((industry) => (
            <IndustryCard key={industry.slug} {...industry} />
          ))}
        </div>
        
        {/* Back to Home */}
        <div className="text-center mt-12">
          <Button variant="outline" asChild>
            <Link to="/#industries">
              ← Back to Home
            </Link>
          </Button>
        </div>
      </main>
    </div>
    <Footer />
  </>
);

export default Industries;